/* Ring Premier — open Shopify Inbox from any "Text our gemologist" link.

   The bare /?chat href works, but it reloads the page and jumps to the top
   before the widget opens. Inbox renders inside a shadow root, so we reach in
   and click its real toggle instead. If the widget isn't present the click
   falls through to normal navigation, so this can never make things worse. */
(function(){
  if(window.__rpdChat) return; window.__rpdChat = 1;

  function toggle(){
    var host = document.querySelector('inbox-online-store-chat, #ShopifyChat');
    if(!host) return null;
    var root = host.shadowRoot || host;
    return root.querySelector('button, [role="button"]');
  }

  /* The widget script loads async, so a click can land before it exists.
     Retry briefly rather than failing silently. */
  function open(tries){
    var b = toggle();
    if(b){ b.click(); return true; }
    if(tries > 0){ setTimeout(function(){ open(tries - 1); }, 250); return true; }
    return false;
  }

  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a[href="/?chat"], a[href$="?chat"], a[href$="#chat"], [data-rpd-chat]');
    if(!a) return;
    if(!document.querySelector('inbox-online-store-chat, #ShopifyChat')) return; /* let the link behave normally */
    e.preventDefault();
    open(8);
  }, true);
})();
